export function formatPrice(number) {
    return Math.round(number)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
